let processFirstUpd = false;
function checkAttr() {
    var attris = document.querySelectorAll(".sk-attr:not(.sk-radio):not(.sk-container):not(.sk-message):not(.sk-attr--disabled)");
    const summaryPage = document.querySelector("[data-process-step-id$='PolicyProcess:Summary']");

    // console.log(processFirstUpd);

    if(!summaryPage && processFirstUpd == true) {
        attris.forEach((attri) => {
            let inputBox = attri.querySelector("input.sk-input");
            let dropdown = attri.querySelector(".react-select__single-value");
            
            if(inputBox) {
                if(inputBox.getAttribute("value")) {
                    // console.log(`input field value = ${inputBox.getAttribute("value")}`);
                    attri.querySelector(".sk-field").classList.add("input--complete");
                } else {
                    attri.querySelector(".sk-field").classList.remove("input--complete");
                }
            } else if (dropdown) {
                if(dropdown.textContent) {
                    // console.log(`dropdown value = ${dropdown.textContent}`);
                    attri.querySelector(".sk-field").classList.add("input--complete");
                } else {
                    attri.querySelector(".sk-field").classList.remove("input--complete");
                }
            } else {
                return;
            }
        })
    }
    processFirstUpd = true;
}

export { checkAttr };